import React from 'react';

const Lock = () => {
    return (
        <svg width={9} height={11.25} viewBox="0 0 9 11.25">
            <path
                d="M4.5 6.188a.838.838 0 00-.562 1.468v.782a.563.563 0 101.125 0v-.782A.838.838 0 004.5 6.187zm2.813-2.25V2.813a2.813 2.813 0 10-5.625 0v1.125A1.688 1.688 0 000 5.625v3.938a1.687 1.687 0 001.688 1.687h5.625A1.687 1.687 0 009 9.563V5.625a1.687 1.687 0 00-1.687-1.687zm-4.5-1.125a1.688 1.688 0 113.375 0v1.125H2.813zm5.062 6.75a.563.563 0 01-.562.563H1.688a.563.563 0 01-.562-.562V5.625a.563.563 0 01.563-.562h5.625a.563.563 0 01.563.563z"
                fill="#000946"
            />
        </svg>
    );
};

export default Lock;
